export const config = {
  hubUrl: (import.meta.env.VITE_HUB_URL as string | undefined) ?? "http://localhost:8787",
  supabaseUrl: (import.meta.env.VITE_SUPABASE_URL as string | undefined) ?? "",
  supabaseAnonKey: (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ?? "",
  adsenseClient: (import.meta.env.VITE_ADSENSE_CLIENT as string | undefined) ?? "",
};

/** Accounts are optional: without Supabase the app runs in guest-only mode. */
export const accountsEnabled = !!(config.supabaseUrl && config.supabaseAnonKey);

export function hubWsUrl(path: string): string {
  return config.hubUrl.replace(/^http/, "ws") + path;
}
